import { type SelectHTMLAttributes, forwardRef } from 'react';
import { cn } from '@/lib/utils';

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  function Select({ className, children, ...props }, ref) {
    return (
      <select
        ref={ref}
        className={cn(
          'h-10 rounded-lg border border-border bg-bg-input px-3 text-sm text-text-primary focus:border-brand focus:outline-none focus:ring-1 focus:ring-brand',
          className
        )}
        {...props}
      >
        {children}
      </select>
    );
  }
);
